import './video-tutorial.scss';

class VideoTutorial {
    constructor (element) {
        this.$videoTutorial = element;
        this.$videosTabs = this.$videoTutorial.querySelectorAll('[data-videos-tab]');
        this.$videosContainer = this.$videoTutorial.querySelectorAll('[data-videos-container]');
        this.$videosContent = this.$videoTutorial.querySelector('[data-videos-content]');

        this.activeTab = this.$videoTutorial.querySelector('[data-videos-container].is--active').getAttribute('data-videos-container');
        this.$activeContainer = this.$videoTutorial.querySelector('[data-videos-container].is--active');
        this.activeHeight = this.$activeContainer.clientHeight;
        this.onHold = false;
    }

    initialize () {
        this.$videosContent.style.height = 'auto';
        this.setEvents();
    }

    setHeight (targetHeight, activeHeight, timer, callback) {
        this.$videosContent.style.height = activeHeight + 'px';

        if (targetHeight !== activeHeight) {
            setTimeout(() => {
                this.$videosContent.style.height = targetHeight + 'px';
            }, 20);
        }

        if (typeof callback === 'function') {
            setTimeout(() => {
                callback();
            }, timer);
        }
    }

    setEvents () {
        this.$videosTabs.forEach(($tab) => {
            $tab.addEventListener('click', () => {
                if (!this.onHold) {
                    const id = $tab.getAttribute('data-videos-tab');

                    if (id !== this.activeTab) {
                        this.onHold = true;

                        this.setHeight(this.$activeContainer.clientHeight, this.$activeContainer.clientHeight, 50, () => {
                            this.setTab($tab);
                            this.setVideoContainer($tab, id);
                        });
                    }
                }
            });
        });
    }

    setTab ($tab) {
        const $activeTab = this.$videoTutorial.querySelector('[data-videos-tab="' + this.activeTab + '"]');

        $activeTab.classList.remove('is--active');

        $tab.classList.add('is--active');
    }

    setVideoContainer (tab, id) {
        const $videoContainer = this.$videoTutorial.querySelector('[data-videos-container="' + id + '"]');
        const $activeVideoContainer = this.$videoTutorial.querySelector('[data-videos-container="' + this.activeTab + '"]');

        $activeVideoContainer.classList.add('is--hidden');
        $activeVideoContainer.classList.remove('is--active');

        this.setHeight($videoContainer.clientHeight, $activeVideoContainer.clientHeight, 500, () => {
            $activeVideoContainer.classList.remove('is--hidden');
            $videoContainer.classList.add('is--active');
            this.onHold = false;
            this.activeTab = id;
            this.$activeContainer = $videoContainer;

            setTimeout(() => {
                this.$videosContent.style.height = 'auto';
            }, 500);
        });
    }
}

export { VideoTutorial };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $videoTutorialRoot = $context.querySelector('[data-videos-section="root"]');

        if ($videoTutorialRoot) {
            const $videoTutorial = new VideoTutorial($videoTutorialRoot);
            $videoTutorial.initialize();
        }
    }
});
